import { getApiUrl } from '../config/api';

/**
 * Generate signed URLs for audio files
 */
export async function generateSignedUrl(audioUrl: string): Promise<string> {
  try {
    const response = await fetch(`${getApiUrl('/video')}/get-signed-download-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify({ videoUrl: audioUrl })
    });

    if (!response.ok) {
      throw new Error(`Failed to get signed URL: ${response.statusText}`);
    }

    const data = await response.json();
    return data.signedUrl;
  } catch (error) {
    console.error('Error generating signed URL:', error);
    throw error;
  }
}
